// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"742":"c669c965","4079":"c669c965","9613":"c669c965"}[chunkId] + ".chunk.css";
};